import sanitizeHtml from 'sanitize-html';

export default function sanitizeContent(content: string) {
  // Remove styling and formatting while keeping HTML structure
  const sanitizedContent = sanitizeHtml(content, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'p',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'a',
      'ul',
      'ol',
      'li',
      'b',
      'i',
      'strong',
      'em',
      'strike',
      'u',
    ]),
    allowedAttributes: {
      a: ['href', 'name', 'target'],
    },
  });

  return sanitizedContent;
}
